<template>
  <span @click="copiarPresupuesto" v-html="codigo ? codigo : /*html*/ `<i class='fa-solid fa-circle-question'></i>`"></span>
</template>

<script>
export default {
  name: "presupuesto",
  props: {
    codigo: String,
    directorio: String,
  },
  methods: {
    copiarPresupuesto() {
      navigator.clipboard.writeText(this.directorio).then(() => {
        this.$toast.success(`Ruta del pressupost ${this.codigo ? /*html*/ `<b>${this.codigo}</b>` : ""} copiada al portapapers.`);
      });
    },
  },
};
</script>